export default "__VITE_ASSET__DTSouA7i__"